import { PropsWithChildren } from "react";
import { DataProvidedBy, DataProvidedByProps } from "../../shared/ui/DataProvidedBy/DataProvidedBy";
import ProgressBar from "@/frontend/shared/ui/ProgressBar/ProgressBar";
import styles from "./SectionContentWrapper.module.scss";

type TProgress = {
  visible?: boolean;
  pct?: number;
};
type SectionWrapperProps = DataProvidedByProps & PropsWithChildren & { progress?: TProgress };

export function SectionContentWrapper(props: SectionWrapperProps) {
  const { children, progress, ...otherProps } = props;

  return (
    <div className={styles.wrapper}>
      <DataProvidedBy {...otherProps} />
      {progress?.visible ? <ProgressBar progress={progress?.pct ?? 0} /> : null}
      <div className={styles.contentWrapper}>{children}</div>
    </div>
  );
}
